export const faqList = [
  {
    faqId: 1,
    question: 'A/S기간은 어떻게 되나요?',
    answer:
      '<p>[일시불 구매시] <br/>기계 하자에 의한 A/S는 1년간 무상이며, 1년이 지난 경우 또는 소비자 과실에 의한 A/S 발생의 경우 출장비 및 부품교체에 따른 비용이 발생할 수 있습니다.</p> <p>[렌탈 구매시]<br/>렌탈 구매시, 기계 하자에 의한 A/S는 렌탈 기간(3년) 간 무상이며, 소비자과실/ 외부요인으로 인한 A/S 발생의 경우 출장비 및 부품교체에 따른 비용이 발생할 수 있습니다.</p> <p>[우노스 풀케어 서비스(관리비) 선택 가입시]<br/>고객과실을 포함한 A/S 발생의 경우 출장비, 공임비, 자재비용 포함하여 무상으로 진행됩니다.<br/>- 외부요인 및 천재지변 제외 <br/>- 연간 120만원 한도 매년 갱신</p>',
    tag: ['AS', '관리비', '보험', '부가상품'],
  },
  {
    faqId: 2,
    question: '포스, 키오스크 용지는 어떻게 받나요?',
    answer:
      '<p>제품 설치 시 처음 제공되는 용지 이후의 추가 용지(감열지)는 유상 구매하실 수 있습니다. <br/> <br/>79*70 사이즈의 감열지는 호환되며, 아래의 링크에서 추가 구매하실 수도 있습니다.<br/> <a href="https://smartstore.naver.com/unospay/products/4670628052" target="_blank"> [용지 추가구매 바로가기]</a> </p>',
    tag: ['영수증', '소모품', 'AS'],
  },
  {
    faqId: 3,
    question: '매장관리 어플리케이션(APP)은 어디서 받나요?',
    answer:
      '<p>앱스토어(iOS), 구글스토어(Android) 모두 지원되며 아래의 링크에서 다운로드 하실 수 있습니다.</p> <a href="https://apps.apple.com/kr/app/%EC%9A%B0%EB%85%B8%EC%8A%A4%ED%8E%98%EC%9D%B4-%EB%A7%A4%EC%B6%9C%EC%A1%B0%ED%9A%8C/id1590971633">[앱스토어 링크]</a> <a href="https://play.google.com/store/apps/details?id=com.unospay.SalesManagement">[안드로이드 링크]</a>',
    tag: ['모바일', '매장관리'],
  },
  {
    faqId: 4,
    question: '매장관리 온라인 페이지는 어디있나요?',
    answer:
      '아래의 매장관리페이지에서 확인하실 수 있습니다.<ol></ol><a href="https://sales.unospay.com/login">https://sales.unospay.com/login</a> </p> <a href="/support/faq/3">[매장관리 어플리케이션(APP)은 어디서 받나요?]</a>',
    tag: ['온라인', '매장관리'],
  },
  {
    faqId: 5,
    question: '매출 조회는 어디서 확인할 수 있나요?',
    answer:
      '<p>매출 조회는 아래와 같은 방법으로 쉽게 조회가 가능합니다.</p><ol><li> 우노스페이 포스 내 \'매출조회\' 버튼</li><li> 매장관리 모바일 애플리케이션(APP) </li><li>온라인 홈페이지의 매장관리 페이지</li></ol> <a href="/support/faq/3">[매장관리 어플리케이션(APP)은 어디서 받나요?]</a> <a href="/support/faq/4">[매장관리 웹페이지]</a>',
    tag: ['모바일', '매장관리'],
  },
  {
    faqId: 6,
    question: '메뉴, 옵션품절은 어디에서 할 수 있나요?',
    answer:
      '아래의 방법으로 메뉴, 옵션의 품절을 쉽게 변경할 수 있습니다.<br/> <ol><li> 매장관리 모바일 애플리케이션(APP) - 재고관리 - 재고수정/품절관리 - 품절체크</li><li>포스/키오스크의 관리자모드 - 메뉴설정</li><li>매장관리 웹페이지</li></ol> 클라우드 기반의 시스템으로, 수정하면 실시간으로 포스와 키오스크 모두 반영됩니다.<a href="/support/faq/3">[매장관리 어플리케이션(APP)은 어디서 받나요?]</a> <a href="/support/faq/4">[매장관리 웹페이지]</a>',
    tag: ['메뉴', '품절', '수정'],
  },
  {
    faqId: 7,
    question: '매장관리자 아이디와 비밀번호가 기억나지 않아요.',
    answer:
      '매장 담당자 또는 우노스 고객센터 1800-4520으로 연락주시면, 본인확인 후 안내 드리도록 하겠습니다.',
    tag: ['계정', '매장관리'],
  },
  {
    faqId: 8,
    question: '기계만 설치하면 바로 카드 결제를 받을 수 있나요?',
    answer:
      '기존 카드 결제를 받고 있던 카드가맹이 된 사업자는 가능합니다.<br/>신규사업자는 카드사에 가맹점등록을 하셔야 카드 결제를 받으실 수 있습니다. <br/><br/>우노스는 신규 사업자에 한에 카드사 가맹서류 제출을 대행하고 있으며 통상 제출일로부터 14일 소요됩니다. <br/>자세한 사항은 기기 설치 전 우노스 가맹전담 담당부서에서 안내받으실 수 있습니다.</p><a href="/support/faq/13">[카드가맹 신청은 어떻게 하나요?]</a>',
    tag: ['카드결제', '설치', '결제', '가맹점'],
  },
  {
    faqId: 9,
    question: '포스, 키오스크, 기능 등을 직접 보고 싶어요.',
    answer:
      '아래의 다양한 방법으로 우노스 제품들을 체험해 보실 수 있습니다. <ol><li> 설치사례 매장 중 가까운 매장에 방문 </li><li> 우노스 쇼룸 예약방문</li><li>우노스 참여 박람회 부스에 방문</li></ol> <p>1800-4520으로 연락주신 후 본사 쇼룸으로 방문하시면 담당직원이 안내 및 상담을 도와드립니다.</p>',
    tag: ['포스', '키오스크'],
  },
  {
    faqId: 10,
    question: '부가세 자료와 매출이 서로달라요.',
    answer:
      '<p>우노스에서 발송 드리는 부가세 자료는 우노스 기기를 통한 결제 내역만 확인 가능하며, 배달사 또는 타업체 기기를 통한 결제건은 별도 확인이 필요합니다.</p><p>또한 기기를 통하지 않은 결제 (카드사에 전화취소 등) 은 부가세 참고자료에 반영되지 않습니다.<br/> 더욱 자세한 내용은 1800-4520 (내선5번) 경영지원부서로 연락하시면 안내드리겠습니다.</p>',
    tag: ['매장관리', '부가세 신고'],
  },
  {
    faqId: 11,
    question: '별도의 결제 수수료가 있나요?',
    answer:
      '우노스는 별도의 추가 결제 수수료를 부과하지 않으며 통상적인 카드 수수료율에 따라 적용됩니다. <ol><li> 카드사 수수료율은 1~3% 사이에서 책정되며, 가맹점의 매출 등 상황에 따라 수수료율은 상이합니다.</li><li> 카드사 매출 입금은 결제일로부터 영업일 기준 2~3일이 소요되며, 카드사의 사정에 따라 소요 기간이 달라질 수 있습니다. </li><li> 여신금융협회 가입 시 카드사 별 수수료율 및 일자별 입금내역을 확인할 수 있습니다.<br/> <a href="https://www.cardsales.or.kr/page/salebook/list">https://www.cardsales.or.kr/page/salebook/list</a> </li><li>자세한 내용은 카드사로 직접 문의하시기 바랍니다. </li> 롯데 1588 8100 <br/> 비씨 1588 4500<br/> 현대 1577 6000<br/> 국민 1588 1788<br/> 삼성 1588 8700<br/> 하나 1588 3200<br/> 신한 1544 7000<br/> 농협 1644 4000</ol>',
    tag: ['모바일', '매장관리'],
  },
  {
    faqId: 12,
    question: '부가세 자료를 받고싶어요.',
    answer:
      '<ol><li>우노스 매장관리 애플리케이션(APP) 또는 사이트 내에 <부가세 신고자료 요청> 메뉴를 통해 요청할 수 있습니다. </li><li>1800-4520 내선5번(경영지원부서)으로 요청할 수 있습니다.</li></ol> <a href="/support/faq/3">[매장관리 어플리케이션(APP)은 어디서 받나요?]</a><a href="/support/faq/4">[매장관리 웹페이지]</a>',
    tag: ['가맹점', '매장관리', '카드결제'],
  },
  {
    faqId: 13,
    question: '카드가맹 신청은 어떻게 하나요?',
    answer:
      '<p>우노스는 신규 가맹점들의 카드 가맹을 서류 신청을 대행하고 있습니다.<br/> 아래의 서류가 충족되어야 하며, 각 카드사에서 심사이후 적용까지 통상적으로 2주의 기간이 소요되며, 카드사 상황에 따라 변동될 수 있습니다.<br/> <br/>*서류미흡으로 인한 카드사 심사 반려의 경우, 추가 보안자료와 재심사 소요기간이 대폭 늘어나 매장 오픈시 카드결제에 차질이 없도록 제출 바랍니다.</p> <ol><li> 개인, 법인 사업자 공통 필요서류 <br/> 사업자등록증 / 영업신고증(요식업) / 통장사본 / 대표자 신분증 / 대표자명의 휴대폰 번호 / 이메일 주소 / 매장 외부 사진 2장 / 매장 내부 사진 2장 </li><li> 법인 사업자 추가 서류 <br/>등기부등본(말소 사항 포함/3개월 이내 발급 본)/법인인감증명서(3개월 이내 발급 본)/주주명부(3개월 이내 발급 본) / 법인고객거래확인서</li><li> 공동대표, 각자대표, 외국인대표, 대리인서명, 미성년자 등 상황에 따라 추가 서류가 발생할 수 있습니다.</li></ol>',
    tag: ['가맹점', '카드결제'],
  },
  {
    faqId: 14,
    question: '간편결제도 사용하고 싶어요.',
    answer:
      '우노스에서는 다음과 같은 다양한 결제수단을 포스/키오스크에서 받으실 수 있으며, 간편결제의 경우 카드가맹 이외에 추가 가맹점 등록이 필요합니다.<br/><br/>삼성페이, LG페이, 카카오페이, 네이버페이, 페이코, 제로페이, 위챗페이, 알리페이, 앱카드 등<ol><li>1800-4520 (내선 5번) 경영지원부서로 별도 신청하여 주세요. </li><li> 신청 및 서류제출 이후 1~2주 정도의 심사일이 소요됩니다.</li>',
    tag: ['간편결제', '가맹점', '카드결제'],
  },
  {
    faqId: 15,
    question: '담배 자판기에서 담배 구매 시 성인 인증은 어떻게 받나요?',
    answer: 'PASS 앱을 통해 성인인증 가능합니다.',
    tag: ['담배자판기', '담배', '자판기', '성인인증'],
  },
  {
    faqId: 16,
    question: '담배 자판기 판매 시 담배 종류 상관없이 판매가 가능한가요?',
    answer:
      '담배 종류는 시중에 판매되는 모든 담배 유형(일반형, 슬림형, 궐련형) 모두 적재 가능합니다.<br/> 또한 48개의 슬롯이 있으며, 한 슬롯당 3갑씩 적재가 가능하여 총 144갑의 담배를 넣을 수 있습니다.',
    tag: ['담배자판기', '담배', '자판기'],
  },
  {
    faqId: 17,
    question: '담배 자판기에서 현금 결제가 가능한가요?',
    answer: '현금 결제는 불가하며, 신용카드만 결제가 가능합니다.',
    tag: ['담배자판기', '담배', '자판기', '현금'],
  },
  {
    faqId: 18,
    question: '담배 자판기는 아무나 구매가 가능한가요?',
    answer:
      '<ol><li>담배 판매권이 있는 매장에 한 하여 구매가 가능합니다.</li><li>교육환경 규제로 학교 경계에서 직선 200m 내 거리에는 설치가 불가합니다.</li></ol>자세한 내용은 아래 링크를 확인해 주세요.<a target="_blank" href="https://www.easylaw.go.kr/CSP/CnpClsMain.laf?popMenu=ov&csmSeq=1138&ccfNo=4&cciNo=1&cnpClsNo=2">[교육환경 보호구역]</a>',
    tag: ['담배자판기', '담배', '자판기', '판매권'],
  },
  {
    faqId: 19,
    question: '담배 자판기 구매 시 담배도 우노스에서 공급이 되나요?',
    answer:
      '당사는 담배 자판기를 공급하는 업체로 담배는 담배공사, 도소매업체를 통해 구매 필요합니다.',
    tag: ['담배자판기', '담배', '자판기'],
  },
  {
    faqId: 20,
    question: '담배 자판기에 적재된 담배 재고 부족 시, 알림이 가나요?',
    answer:
      '현재는 알람이 가지 않고, 재고 부족 시에만 자동으로 ‘품절 처리’ 됩니다.',
    tag: ['담배자판기', '담배', '자판기', '재고'],
  },
];
